var React = require('react');

function Ro (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#ffda44","d":"M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z","key":0}),React.createElement("path",{"fill":"#0052b4","d":"M0 0h167v512H0z","key":1}),React.createElement("path",{"fill":"#d80027","d":"M345 0h167v512H345z","key":2})])]);
}

Ro.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Ro;

Ro.default = Ro;
